module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-LightOblique.a68c6e9a.ttf";